"use client";

import type { ComponentProps } from "react";
import { CleanProductCard } from "./variants/clean";
import { LuxuryProductCard } from "./variants/luxury";
import { StickerProductCard } from "./variants/sticker";
import { CompactProductCard } from "./variants/compact";
import { BotanicalProductCard } from "./variants/botanical";
import { useSectionVariant } from "@/components/theme/theme-variant-provider";

const CARD_VARIANTS = {
  clean: CleanProductCard,
  luxury: LuxuryProductCard,
  sticker: StickerProductCard,
  compact: CompactProductCard,
  botanical: BotanicalProductCard,
} satisfies Record<string, typeof CleanProductCard>;

type ProductCardProps = ComponentProps<typeof CleanProductCard> & { variant?: string };

export function ProductCard({ variant, ...props }: ProductCardProps) {
  const ctxVariant = useSectionVariant("productCard", "clean"); // hook her zaman çağrılır (rules-of-hooks)
  const active = variant ?? ctxVariant;
  const Cmp = CARD_VARIANTS[active as keyof typeof CARD_VARIANTS] ?? CARD_VARIANTS.clean;
  return <Cmp {...props} />;
}
